export default "__VITE_ASSET__244f1701__"